module.exports = __webpack_public_path__ + "static/media/mso.226a8df2.jpeg";